export default class NodeDefinitionClassDico {
	/**
	 * @param {any} [dico]
	 */
	constructor(dico = null) {
		this.data = dico?.data;
		this.internal = !!dico?.internal;
		this.linker_info = dico?.linker_info;
		this.linker_kid = dico?.linker_kid ?? '0';
		this.lock = Number.parseInt(dico?.lock ?? 0);
		this.objnum2_info = dico?.objnum2_info ?? {};
		this.objnum2_kid = dico?.objnum2_kid;
		this.relation_kid = dico?.relation_kid;
	}
}
